import classNames from 'classnames';
import StatusIcon from './StatusIcon';
import { useHideGetItBy, useHideShipping, useShippingCost } from '../hooks';

type OwnProps = {
  getItBy: string;
};

export default function Shipping({ getItBy }: OwnProps) {
  const shippingCost = useShippingCost();
  const hideShipping = useHideShipping();
  const hideDot = useHideGetItBy(getItBy);
  const costText = shippingCost > 0 ? `$${shippingCost.toLocaleString()}` : '';
  const divider = ' • ';
  const shippingText = shippingCost ? `Shipping: ` : 'Free Shipping';

  return (
    <div
      data-qa="shipping-cost"
      className={classNames('flex gap-4 items-center mr-4 text-blue-6', {
        hidden: hideShipping,
        'font-bold': !shippingCost
      })}
    >
      {!hideShipping && !shippingCost && <StatusIcon />}
      {shippingText}
      {costText && <span className="font-normal">{costText}</span>}
      {hideDot ? null : divider}
    </div>
  );
}
